export const FAST_INTERVAL_SOLANA = 6000;
export const NATIVE_ADDRESS_SOLANA = "11111111111111111111111111111111";
